export {
  default as BottomNav,
  type BottomNavItemConfig,
} from './BottomNav.vue';
